<div class="wrapper">
  Sorry, something went wrong
  <p-button (click)="askForNewToken()" label="Try again" [loading]="working"></p-button>
</div>
